const store = require('./store')
const EventEmitter = require('events');
let emitter = new EventEmitter();
const {token} = require("./request");
const { io } = require("socket.io-client") ;
let socket = null;

const eventPool = {};

function init(server) {
    socket = io(server, {
        auth: (cb) => {
            cb(token());
        },
        withCredentials: true
    });
    socket.connect();
    addEventHandlers();
    socket.on("disconnect", (reason) => {
        console.log('disconnect', reason)
    });
}

function addEventHandlers() {

    socket.removeAllListeners();
    socket.offAny();

    socket.on("connect", () => {console.log('Socket Connected');});

    socket.on("syncComplete", (data) => {
        emitter.emit('syncStat', data)
    })

    socket.onAny((eventName, payload) => {
        // Check If Controller Event
        if (payload && typeof payload === 'object' && payload.updateEvent) {
            // Add To The Pool
            eventPool[eventName] = payload.payload
            setTimeout(() => {
                delete eventPool[eventName]
            }, 5000);
            // Do The Upsert
            store.default.dispatch('upsert', payload.payload || true)
            // Emit An Event For Success
            emitter.emit(eventName, {status: payload.status, payload: payload.payload})
        }
    });
}

function socketMessage(type, body) {
    socket.emit(type, body)
    return true
}

function waitForEvent(eventID, timeout = 15000) {

    return new Promise((resolve, reject) => {

        // Check If Event Has Not Fired Yet
        if (typeof eventPool[eventID] == 'undefined') {
            let timedOut = false;
            let failTimeOut = setTimeout(() => {
                timedOut = true
                let error = new Error('Timeout Exceeded')
                error.data = `Timeout Length:${timeout}ms`

                reject(error)
            }, timeout)

            emitter.once(eventID, (data) => {
                if (!timedOut) {
                    clearTimeout(failTimeOut)
                    if (data.status) {
                        resolve(data.payload ? data.payload : true)
                    } else {
                        reject(data.payload)
                    }
                }
            })
        } else {
            resolve(eventPool[eventID]);
        }
    })
}


const initSocket = init;

module.exports = {
    initSocket,
    socketMessage,
    waitForEvent,
    socketEvents: emitter
}